import { generateQRCode } from "../services/WalletService";

export const BTC_DONATION_ADDRESS = "bc1qacadrs8hhkn9zqnnt2d4m2zejszuhed7pzf953";

export const BTC_DONATION_ADDRESS_QR_CODE_URL = await generateQRCode(BTC_DONATION_ADDRESS);